"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachmentSchema = void 0;
var constants_1 = require("@hobt/constants");
var constants_2 = require("../../constants");
exports.attachmentSchema = {
    type: 'object',
    required: [],
    properties: {
        description: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 1000,
            errorMessage: 'Should be a string with a maximum of 1000 characters or null',
        },
        documentID: {
            type: ['string', 'null'],
            pattern: '^({{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}}{0,1})$',
        },
        documentType: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_2.ClaimDocumentType), [null]),
            errorMessage: 'Should equate to a valid ClaimDocumentType Enum value or null',
        },
        fileName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        fileSize: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        fileType: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_2.ClaimFileType), [null]),
        },
        status: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_1.Status), [null]),
            errorMessage: 'Should equate to a valid Status Enum value or null',
        },
    },
};
